(function () {
  initAll();

  document.addEventListener("shopify:section:load", initAll);
  document.addEventListener("xo:section:load", initAll);

  function initAll() {
    document.querySelectorAll(".xo-product-dock").forEach((root) => {
      if (root.dataset.dockInitialized === "true") return;
      root.dataset.dockInitialized = "true";
      initDock(root);
    });
  }

  function initDock(root) {
    // Scroll container (as per your CSS)
    const rail = root.querySelector(".xo-product-dock__icons");
    const icons = Array.from(root.querySelectorAll(".dock-icon"));
    if (!rail || !icons.length) return;

    const mqDesktop = window.matchMedia("(hover: hover) and (min-width: 768px)");
    const mqMobile = window.matchMedia("(max-width: 767px)");
    const isDesktop = mqDesktop.matches;
    const isMobile = mqMobile.matches;

    // Arrows
    const btnPrev = root.querySelector("[data-dock-prev]");
    const btnNext = root.querySelector("[data-dock-next]");

    /* =========================
       ACTIVE FROM URL (safe match)
    ========================= */
    setActiveFromUrl();

    // Center active on load (double pass for late image sizing)
    raf(() => {
      centerActive("auto");
      setTimeout(() => centerActive("auto"), 220);

      // arrows state after centering
      setTimeout(updateNavState, 60);
      setTimeout(updateNavState, 260);
    });

    /* =========================
       DESKTOP: DOCK BEHAVIOR
    ========================= */
    if (isDesktop) {
      bindDesktopHoverAndClick();
      bindCtrlWheelHorizontalScroll();
      bindArrowsDesktopOnly();
    }

    /* =========================
       MOBILE: CAROUSEL BEHAVIOR (unchanged)
    ========================= */
    if (isMobile) {
      bindMobileActiveClosest();
    }

    // Keep arrow state fresh on resize
    window.addEventListener("resize", () => raf(updateNavState));

    /* =========================
       FUNCTIONS
    ========================= */

    function setActiveFromUrl() {
      const path = normalizePath(window.location.pathname);

      let match = null;
      for (const icon of icons) {
        const href = icon.getAttribute("href") || "";
        const hrefPath = normalizePath(href);
        if (!hrefPath) continue;

        if (path === hrefPath) {
          match = icon;
          break;
        }
      }

      setActiveIcon(icons, match || icons[0]);
    }

    function centerActive(behavior) {
      const active = root.querySelector(".dock-icon.is-active");
      if (active) centerIcon(active, rail, behavior || "smooth");
    }

    function bindDesktopHoverAndClick() {
      icons.forEach((icon, index) => {
        icon.addEventListener("mouseenter", () => {
          clearHover(icons);
          icon.classList.add("is-hovered");
          if (icons[index - 1]) icons[index - 1].classList.add("is-near");
          if (icons[index + 1]) icons[index + 1].classList.add("is-near");
        });

        icon.addEventListener("mouseleave", () => {
          clearHover(icons);
        });

        icon.addEventListener("click", () => {
          setActiveIcon(icons, icon);
          centerIcon(icon, rail, "smooth");
          raf(updateNavState);
        });
      });
    }

    function bindCtrlWheelHorizontalScroll() {
      let hoveringDock = false;
      root.addEventListener("mouseenter", () => (hoveringDock = true));
      root.addEventListener("mouseleave", () => (hoveringDock = false));

      root.addEventListener(
        "wheel",
        (e) => {
          if (!hoveringDock) return;
          if (!e.ctrlKey) return;

          e.preventDefault();

          const SPEED = 1.35; // tweak 1.1–2.0
          rail.scrollBy({ left: e.deltaY * SPEED, behavior: "auto" });

          raf(updateNavState);
        },
        { passive: false }
      );
    }

    function bindMobileActiveClosest() {
      let ticking = false;

      rail.addEventListener("scroll", () => {
        if (ticking) return;
        ticking = true;

        raf(() => {
          let closestIcon = null;
          let closestDistance = Infinity;

          icons.forEach((icon) => {
            const rect = icon.getBoundingClientRect();
            const iconCenter = rect.left + rect.width / 2;
            const distance = Math.abs(iconCenter - window.innerWidth / 2);

            if (distance < closestDistance) {
              closestDistance = distance;
              closestIcon = icon;
            }
          });

          if (closestIcon) setActiveIcon(icons, closestIcon);
          ticking = false;
        });
      });
    }

    function bindArrowsDesktopOnly() {
      if (!btnPrev || !btnNext) return;

      // desktop only
      if (!mqDesktop.matches) {
        btnPrev.style.display = "none";
        btnNext.style.display = "none";
        return;
      }

      btnPrev.style.display = "";
      btnNext.style.display = "";

      btnPrev.addEventListener("click", (e) => {
        e.preventDefault();
        rail.scrollBy({ left: -getStep(), behavior: "smooth" });
        raf(updateNavState);
      });

      btnNext.addEventListener("click", (e) => {
        e.preventDefault();
        rail.scrollBy({ left: getStep(), behavior: "smooth" });
        raf(updateNavState);
      });

      rail.addEventListener("scroll", () => raf(updateNavState));

      // initial
      setTimeout(updateNavState, 50);
      setTimeout(updateNavState, 300);
    }

    function getStep() {
      const first = icons[0];
      if (!first) return 220;

      const w = first.getBoundingClientRect().width || 0;
      const styles = window.getComputedStyle(rail);
      const gap = parseFloat(styles.gap || styles.columnGap || "0") || 0;

      return Math.max(180, w + gap);
    }

    function updateNavState() {
      if (!btnPrev || !btnNext) return;
      if (!mqDesktop.matches) return;

      const maxScroll = rail.scrollWidth - rail.clientWidth;
      const x = rail.scrollLeft;

      const atStart = x <= 2;
      const atEnd = x >= maxScroll - 2;

      btnPrev.classList.toggle("is-disabled", atStart);
      btnNext.classList.toggle("is-disabled", atEnd);
    }
  }

  /* =========================
     HELPERS (same)
  ========================= */

  function clearHover(icons) {
    icons.forEach((i) => i.classList.remove("is-hovered", "is-near"));
  }

  function setActiveIcon(icons, activeIcon) {
    icons.forEach((i) => i.classList.remove("is-active"));
    if (activeIcon) activeIcon.classList.add("is-active");
  }

  function centerIcon(icon, container, behavior) {
    const iconRect = icon.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();

    const offset =
      iconRect.left -
      containerRect.left -
      containerRect.width / 2 +
      iconRect.width / 2;

    container.scrollBy({ left: offset, behavior: behavior || "smooth" });
  }

  function normalizePath(urlOrPath) {
    try {
      const u = new URL(urlOrPath, window.location.origin);
      return u.pathname.replace(/\/+$/, "");
    } catch (e) {
      return (urlOrPath || "").split("?")[0].replace(/\/+$/, "");
    }
  }

  function raf(fn) {
    requestAnimationFrame(fn);
  }
})();
